// roleModel.js
import PropTypes from 'prop-types';

export const RoleDetailPropTypes = PropTypes.shape({
    detailValue: PropTypes.oneOf(['true', 'false']).isRequired,
    detailDescription: PropTypes.string.isRequired,
});

export const RolePropTypes = PropTypes.shape({
    username: PropTypes.string.isRequired,
    roleID: PropTypes.string.isRequired,
    roleName: PropTypes.string.isRequired,
    roleDetails: PropTypes.arrayOf(RoleDetailPropTypes).isRequired,
});